import React from 'react';
import { Radio, RadioGroup } from 'react-form';

const InlineRadio = (props) => {
    const {
        id,
        options,
        disabled,
        onChange,
        controlled,
        value,
        field,
        className,
        ...rest
    } = props;

    return (
        <div
            className={`inline-radio noselect ${disabled ? 'disabled' : ''} ${className}`}
            onChange={(ev) => {
                if (onChange) {
                    onChange(ev);
                }
            }}
        >
            {!controlled ? (
                <RadioGroup field={field}>
                    {options.map(option => (
                        <div className="d-flex aic mb8">
                            <Radio
                                id={`${field}-${option.value}`}
                                value={option.value}
                                disabled={disabled}
                                checked={value === option.value}
                                {...rest}
                            />
                            <label htmlFor={`${field}-${option.value}`} className="mb0">&nbsp;{option.label}</label>
                        </div>
                    ))}
                </RadioGroup>
            ) : (
                options.map(option => (
                    <>
                        <input
                            type="checkbox"
                            id={`${field}-${option.value}`}
                            value={option.value}
                            disabled={disabled}
                            checked={value === option.value}
                            name={field}
                            {...rest}
                        />
                        <label htmlFor={`${field}-${option.value}`}>&nbsp;{option.label}</label>
                    </>
                ))
            )}
        </div>
    );
};

InlineRadio.defaultProps = {
    controlled: false,
};

export default InlineRadio;
